import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

const UnitEdit = () => {
  const users = {
    unit_name: "",
    status: "",
  };

  const [UnitEditUser, setUnitEditUser] = useState(users);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPedagogyData = async () => {
      try {
        const response = await axios.post(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_Unit_by_id",
          {
            unit_id: id,
          }
        );
        setUnitEditUser(response.data.data);
      } catch (error) {
        console.error("Error fetching Pedagogy data!", error);
      }
    };

    fetchPedagogyData();
  }, [id]);

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setUnitEditUser({ ...UnitEditUser, [name]: value });
  };

  const submitForm = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/update_unit",
        {
          unit_id: id,
          ...UnitEditUser,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

    
        toast.success(response.data.message || "Data Updated Successfully!");
        navigate("/Unit-list");

    } catch (error) {
      console.error(
        "There was an error!",
        error.response?.data || error.message
      );
      toast.error("Something went wrong!");
    }
  };

  return (
    <div className="page-content">
      {/* Start Container Fluid */}
      <div className="container-fluid">
        {/* ========== Page Title Start ========== */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Unit Edit</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript: void(0);">Unit</a>
                </li>
                <li className="breadcrumb-item active">Unit Edit</li>
              </ol>
            </div>
          </div>
        </div>
        {/* ========== Page Title End ========== */}
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Edit Unit</h4>
              </div>
              <form onSubmit={submitForm}>
                <div className="card-body">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label
                          htmlFor="unit_name"
                          className="form-label text-dark"
                        >
                          Unit Name
                        </label>
                        <input
                          type="text"
                          id="unit_name"
                          name="unit_name"
                          className="form-control"
                          placeholder="Enter Unit Name"
                          value={UnitEditUser.unit_name}
                          onChange={changeHandler}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label htmlFor="status" className="form-label">
                          Status
                        </label>
                        <select
                          className="form-control"
                          id="status"
                          name="status"
                          value={UnitEditUser.status}
                          onChange={changeHandler}
                          required
                        >
                          <option value="">Select Status</option>
                          <option value="Active">Active</option>
                          <option value="InActive">InActive</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer border-top">
                  <button type="submit" className="btn btn-primary">
                    Edit Change
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* End Container Fluid */}
      {/* ========== Footer Start ========== */}
      <footer className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              © Venton. Crafted by{" "}
              <iconify-icon
                icon="iconamoon:heart-duotone"
                className="fs-18 align-middle text-danger"
              />{" "}
              <a href="" className="fw-bold footer-text" target="_blank">
                Techzaa
              </a>
            </div>
          </div>
        </div>
      </footer>
      {/* ========== Footer End ========== */}
    </div>
  );
};

export default UnitEdit;
